import React from 'react'

import IconHeaderBlock from 'storybook/icon-header-block'

import { IconType } from 'storybook/design-constants'
import { ExplanationType } from '../../../../lib/translation-explanations'

type Props = {
   explanation: string | undefined
   explanationType: ExplanationType
}

const ExpandedExplanation = (props: Props) => {
   if (props.explanationType === ExplanationType.Untranslatable) {
      return (
         <div className="text-bodyBlack max-w-[700px] leading-[1.5] md:ml-[55px] md:mt-[20px]">
            <span dangerouslySetInnerHTML={{ __html: props.explanation! }} />.
         </div>
      )
   }

   if (props.explanationType === ExplanationType.MoreDetail) {
      return (
         <div className="mt-[25px] text-[17px]">
            <IconHeaderBlock
               iconType={IconType.Insight}
               explanation={props.explanation!}
               headerText="More Detail"
            />
         </div>
      )
   }

   return null
}

export default ExpandedExplanation
